var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row step-row justify-content-center"},[_c('div',{staticClass:"\n\t\t\tstep-items-wrapper\n\t\t\tscrollable-list\n\t\t\tform-row\n\t\t\tjustify-content-center\n\t\t"},[_vm._l((_vm.items),function(item){return [_c('div',{key:item.value,staticClass:"step-item"},[_c('button',{staticClass:"btn btn-list btn-lg form-control",class:{
						active:
							item.value === _vm.selectedValue ||
							(_vm.selectedValue === null &&
								item.value === _vm.value),
					},on:{"click":function($event){return _vm.click(item.value)}}},[_vm._v(" "+_vm._s(item.text)+" ")])])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }